export default {
    skipValidations: false, // __DEV__ ? true : false,
    appCenterAnalytics: true,
    historyDefault: 100,
    historyMaterialDDTDefault: 100,
    blacklistTimeoutMin: 120,
    enableIntroSlider: true
};